module.exports = __webpack_public_path__ + "c70e8d706231569d5cabbb0f674b70e4.svg";